import { createApp }    from 'vue'
import App              from '@/App'
import router           from '@/router'
import store            from '@/store'
import VueTheMask       from 'vue-the-mask'
import Notifications    from '@kyvg/vue3-notification'
import crypto           from '@/helpers/crypto'
import { axiosHandler } from '@/handler/axiosHandler'
import './registerServiceWorker'

const app = createApp(App)
app.config.globalProperties.$user = localStorage.getItem('user') ? JSON.parse(crypto.decrypt(localStorage.getItem('user'))) : ''
app.use(store)
app.use(router)
app.use(VueTheMask)
app.use(Notifications)
app.use(axiosHandler)
app.mount('#kt_body')
